<script>
import ListDefault from "../Utils/Page/ListDefault";
import dayjs from "dayjs";

export default {
    name: "ArtiProMembershipList",
    mixins: [ListDefault],
    data() {
        return {
            lang: this.$ml.get('pages.artiProMembership'),

            filter: {
                user_id: { value: null, type: 'text'},
                plan_id: { value: null, type: 'select', options: []},
                braintree_id: { value: null, type: 'text'},
                promo_code_id: { value: null, type: 'select', options: [], title_key: 'code'},
                promo_code_renew_id: { value: null, type: 'select', options: [], title_key: 'code'},
                active: { value: null, type: 'select',
                    options: [
                        { id: false, title: this.$ml.get('interface.no') },
                        { id: true, title: this.$ml.get('interface.yes') },
                    ]
                },
            },

            tableHeader: [
                //{ label: '#', is_sort: false },
                { key: 'id', is_sort: true },
                { key: 'company_id', is_sort: true, classes: 'text-l' },
                { key: 'user_id', is_sort: true, classes: 'text-l' },
                { key: 'plan_id', is_sort: true, classes: 'text-l' },
                { key: 'braintree_id', is_sort: true, classes: 'text-l' },
                //{ key: 'payment', is_sort: true, classes: 'text-l' },
                { key: 'promoCode', is_sort: true, classes: 'text-l' },
                //{ key: 'promoCodeRenew', is_sort: true, classes: 'text-l' },
                { key: 'active', is_sort: true, classes: 'text-l' },
                { key: 'startAt', is_sort: true, classes: 'text-l' },
            ],

            tableBody: {
                promoCode: { type: 'function', function: this.getPromoCode },
                //promoCodeRenew: { type: 'function', function: this.getPromoCodeRenew },
                active: { type: 'function', function: this.getActive },
                startAt: { type: 'function', function: this.getStartAt },
                company_id: {
                    type: 'function',
                    function: this.getCompany,
                },
                user_id: {
                    type: 'dictionary',
                    index: 'id',
                    local_index: 'user_id',
                    label: 'name',
                    dictionary: 'user_id'
                },
                plan_id: {
                    type: 'dictionary',
                    index: 'id',
                    local_index: 'plan_id',
                    label: 'title',
                    dictionary: 'plan_id'
                },
            },

            apiList: this.$store.getters.getApiUrl('artiProMembership'),
            pageRoute: 'artiProMembership',
            pageRouteCreate: 'artiProMembership.create',
            pageRouteEdit: 'artiProMembership.edit',
        }
    },
    mounted() {
        this.getDictionaries().then(({data}) => {
            this.dictionaries = data.dictionaries

            for (let key in this.filter) {
                if (this.dictionaries[key]) {
                    this.filter[key].options = this.dictionaries[key]
                }
            }
        })
    },
    methods: {
        getPromoCode(item) {
            return item.promo_code ? item.promo_code.code : '-';
        },
        getPromoCodeRenew(item) {
            return item.promo_code_renew ? item.promo_code_renew.code : '-';
        },
        getActive(item) {
            return item.active ? 'Yes' : 'No';
        },
        getStartAt(item) {
            return item.start_at ? dayjs(item.start_at).format('MM/DD/YYYY') : '-';
        },
        getCompany(item) {
            let link = this.$router.resolve({name: 'company.edit', params: {id: item.company_id}})
            let hashTag = '#' + item.company.tag?.replace(/^#/, '')
            return `<a class="link" href="${link.href}" target="_blank">${item.company.company_name}</a> ${hashTag}`
        }
    }
}
</script>

<style scoped>

</style>
